import styles from './ScrollCta.module.css';

const ScrollCta = ({
  text,
  targetId,
  textFontSize,
  arrowWidth,
  arrowHeight,
  buttonPadding,
}) => {
  const handleClick = () => {
    if (!targetId) return;
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const styleVars = {
    ...(textFontSize ? { '--scroll-cta-text-font-size': textFontSize } : {}),
    ...(arrowWidth ? { '--scroll-cta-arrow-width': arrowWidth } : {}),
    ...(arrowHeight ? { '--scroll-cta-arrow-height': arrowHeight } : {}),
    ...(buttonPadding ? { '--scroll-cta-button-padding': buttonPadding } : {}),
  };

  return (
    <div className={styles['scroll-cta-wrapper']}>
      <button
        type="button"
        className={styles['scroll-cta__button']}
        onClick={handleClick}
        style={styleVars}
      >
        <span className={styles['scroll-cta__text']}>{text}</span>
        <span className={styles['scroll-cta__arrow-container']} aria-hidden="true">
          <svg className={styles['scroll-cta__arrow-icon']} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 7L17 17M17 17V7M17 17H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
      <span id={targetId || undefined} className={styles['scroll-cta__end']} aria-hidden="true" />
    </div>
  );
};

export default ScrollCta;
